import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Campaign, Collab } from '@foodfluence/shared';
import ModalShell from '../../../../components/ui/ModalShell';
import { ReasonRadios, SheetButton, SheetFooter, SheetHeader, useBrand } from './sheetParts';

interface CounterReasonModalProps {
  isOpen: boolean;
  onClose: () => void;
  onBack: () => void;
  onSubmit: (reason: string) => void;
  collab: Collab;
  campaign: Campaign;
  /** When set, the chosen reason is handed here instead of opening the Counter Offer page. */
  onReasonSelected?: (reason: string) => void;
}

const COUNTER_REASONS = ['Not enough compensation', 'Too many deliverables'];

/** Step 1 of the counter: why. Step 2 is the counter form (page, or modal from the chat). */
const CounterReasonModal: React.FC<CounterReasonModalProps> = ({ isOpen, onClose, collab, campaign, onReasonSelected }) => {
  const [reason, setReason] = useState<string | null>(null);
  const navigate = useNavigate();
  const brand = useBrand(collab, campaign);

  const handleSubmit = () => {
    if (!reason) return;
    if (onReasonSelected) {
      onReasonSelected(reason);
      return;
    }
    navigate(`/collabs/counter-collab`, { state: { collab, campaign, reason } });
  };

  return (
    <ModalShell
      isOpen={isOpen}
      onClose={onClose}
      hideClose
      footer={
        <SheetFooter>
          <SheetButton tone="outline" onClick={onClose}>Cancel</SheetButton>
          <SheetButton onClick={handleSubmit} isDisabled={!reason}>Continue</SheetButton>
        </SheetFooter>
      }
    >
      <SheetHeader
        title="Counter offer"
        onClose={onClose}
        step={{ index: 1, total: 2, name: 'Reason' }}
        sub={`What should ${brand.name} know?`}
      />
      <ReasonRadios label="Counter reason" options={COUNTER_REASONS} value={reason} onChange={setReason} />
    </ModalShell>
  );
};

export default CounterReasonModal;
